import React from 'react'
import Tabs from '../../basic/Tabs'
import {browserHistory} from "react-router";
import Table from '../../basic/Table'
import ListTable from '../../basic/ListTable'
import Image from '../../basic/image'
import getImgUrl from "../../getImgUrl";
import * as media from '../../media'
import styled from 'styled-components'
import CustomizedSwiper from '../../basic/CustomizedSwiper'
import TranslateText from "../../text/modal";

const BiggerThan1000Check = styled.div`
  ${media.smallerThan(600)`display:none;`}
`

const LessThan1000Check = styled.div`
text-align: center;
  ${media.biggerThan(601)`display:none;`}
`

function CarsSuitableSelection({variants, selectedTab, setSelectedTab}) {
  const key = selectedTab && Object.keys(variants).find(e => variants[e].name == selectedTab)
  const list = selectedTab && variants[key].list
  return (
    <div style={{display: (!list || !Object.keys(list).length) && 'none'}}>
      <BiggerThan1000Check>
        <Tabs
          tabs={
            (variants ? Object.keys(variants) : [])
              .map(key => variants[key].name)
          }
          selected={selectedTab}
          setSelected={setSelectedTab}
        />
      </BiggerThan1000Check>
      <LessThan1000Check>
        {
          (variants ? Object.keys(variants) : []).length == 1 ? <Tabs
              tabs={
                (variants ? Object.keys(variants) : [])
                  .map(key => variants[key].name)
              }
              selected={selectedTab}
              setSelected={setSelectedTab}
            />
            :
            <CustomizedSwiper
              options={{slidesPerView: 2}}
              list={(variants ? Object.keys(variants) : []).map(key => {
                const v = variants[key].name
                return (
                  <div
                    style={{
                      display: 'inline-block',
                      ...(selectedTab == v && {background: 'gray',}),
                      cursor: 'pointer',
                      padding: '20px 30px 20px 30px',
                      width: '100%',
                      border: '1px solid rgb(222,222,222)',
                    }}
                    onClick={() => {
                      setSelectedTab(v)
                    }}
                  >
                    {v}
                  </div>
                )
              })}
            />
        }

      </LessThan1000Check>
      <ListTable canOpen={(Object.keys(list) || []).length > 4}>
        <Table>
          <thead>
          <tr>
              <TranslateText
                  id="cars_items__table_header__model"
                  place="bottom"
                  render={text => <th>{text}</th>}
              />
              <TranslateText
                  id="cars_items__table_header__year"
                  place="bottom"
                  render={text => <th>{text}</th>}
              />
              <TranslateText
                  id="cars_items__table_header__engine_type"
                  place="bottom"
                  render={text => <th>{text}</th>}
              />
              <TranslateText
                  id="cars_items__table_header__engine_power"
                  place="bottom"
                  render={text => <th>{text}</th>}
              />
              <TranslateText
                  id="cars_items__table_header__engine_capacity"
                  place="bottom"
                  render={text => <th>{text}</th>}
              />
          </tr>
          </thead>
          <tbody>
          {
            (Object.keys(list) || []).map(key => {
              let src;
              try {
                const img = list[key].image_list.split(',')[0]
                src = img ? getImgUrl(`/media/static/product_photos/${img}`) : null
              } catch (e) {
                src = ''
              }
              const e = list[key]
              return (
                <tr>
                  <td
                    onClick={() => {
                      const manufacture = e.filters.manufacturer_id
                      const model = e.filters.model_id
                      const generation = e.filters.generation_id
                      const variant = e.filters.variant_id
                      const engine = e.filters.engine_id
                      browserHistory.push(`/selection?manufacturer_id=${manufacture}&model_id=${model}&generation_id=${generation}&variant_id=${variant}&engine_id=${engine}`)
                    }}
                    style={{
                      cursor: 'pointer',
                      color: 'blue',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {src && <Image style={{maxHeight: 70, maxWidth: 70}} src={src} />}
                      {<div style={{ marginLeft: 10, }}>{e.variant_display_name}</div>}
                    </div>
                  </td>
                  <td>{e.period}</td>
                  <td>{e.engine_type}</td>
                  <td>{e.power}</td>
                  <td>{e.capacity_tech}</td>
                </tr>
              )
            })
          }
          </tbody>
        </Table>
      </ListTable>
    </div>
  )
}

export default CarsSuitableSelection



// WEBPACK FOOTER //
// ./src/finwhale/common/CarsSuitableSelection.js